/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { requestWithStatusHandling } from './api-status-handler';

export const getAllBrands = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_BRANDS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllBrands:-', error);
    throw error;
  }
};

export const getAllSeasons = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_SEASONS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllSeasons:-', error);
    throw error;
  }
};

export const getAllCategory1 = async (data) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_CATEGORY_1}`,

      { ...data },
    );
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCategory1:-', error);
    throw error;
  }
};

export const getAllCategory2 = async (data) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_CATEGORY_2}`,

      { ...data },
    );
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCategory2:-', error);
    throw error;
  }
};

export const getAllCategory3 = async (data) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_CATEGORY_3}`,

      { ...data },
    );
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCategory3:-', error);
    throw error;
  }
};

export const getAllCategory4 = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_CATEGORY_4}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCategory4:-', error);
    throw error;
  }
};

export const getMultipleCategories = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MULTI_CATEGORIES}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCategory4:-', error);
    throw error;
  }
};

export const getAllLengths = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_LENGTHS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllLengths:-', error);
    throw error;
  }
};

export const getAllCompositions = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_COMPOSITIONS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCompositions:-', error);
    throw error;
  }
};

export const getAllMaterialPlacments = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_MATERIAL_PLACMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllMaterialPlacements:-', error);
    throw error;
  }
};

export const getAllLabelPlacments = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_LABEL_PLACMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCategory2:-', error);
    throw error;
  }
};

export const getAllMainSamples = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_MAIN_SAMPLE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllMainSamples:-', error);
    throw error;
  }
};

export const getAllPCTypes = async (data, isFromSystemMaster) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_PC_TYPE}`, {
      params: { ...data, isFromSystemMaster },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllPCTypes:-', error);
    throw error;
  }
};

export const getAllOtherSamples = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_OTHER_SAMPLES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllOtherSamples:-', error);
    throw error;
  }
};

export const getAllPOSizeMaster = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_PO_SIZE_MASTER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllPOSizeMaster:-', error);
    throw error;
  }
};

export const getAllBOMTypes = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_BOM_TYPE_MASTER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllBOMTypes:-', error);
    throw error;
  }
};

export const getAllBOMSubTypes = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_BOM_SUB_TYPE_MASTER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllBOMSubTypes:-', error);
    throw error;
  }
};

export const getAllProductStatus = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_PRODUCT_STATUS_MASTER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllProductStatus:-', error);
    throw error;
  }
};

export const setDefaultProductStatus = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_DEFAULT_PRODUCT_STATUS}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: setDefaultProductStatus:-', error);
    throw error;
  }
};

export const getAllUnits = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_UNIT_MASTER}`, { params: { ...data } });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllUnits:-', error);
    throw error;
  }
};

export const getAllCustomAccordian = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_FOR_CUSTOM_ACCORDIAN}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postAllCustomAccordian = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_FOR_CUSTOM_ACCORDIAN}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInactiveNewAccordian = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_FOR_CUSTOM_ACCORDIAN}`, data, {
      params: { id: data._id },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getNewAccorianDetail = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_NEW_ACCORDIAN}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postNewAccorianDetail = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.POST_NEW_ACCORIAN}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}/masters/${data.title}`, data, {
      params: { id: data._id },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteFromSystemMaster = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}/masters/${data.title}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveRespectiveData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}/masters/${data?.title}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllSampleTracking = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_SAMPLE_TRACKING}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllSampleStatus = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_SAMPLE_STATUS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setSTSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_ST_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setSSSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_SS_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllSampleSpecification = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.SAVE_SAMPLE_IMAGES}/${data.smapleId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSizeSampleSpecification = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SAMPLES.SIZE_SAMPLE_MEASUREMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllFinals = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_FINALS}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getAllCustomAttribute = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_ATTRIBUTE}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setCustAttrSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_CUST_ATTR_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllMeasurement = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MEASUREMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setMMSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_MM_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const setPMSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_PM_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveExhangeRateService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.EXCHANGE_RATE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchExchangeRateService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.EXCHANGE_RATE}`, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllPlacement = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_PLACEMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setSysMasterAccess = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.SET_MASTER_ACCESS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUserBrands = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_USER_BRANDS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getUserBrands:-', error);
    throw error;
  }
};

export const getUserCategories = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_USER_CATEGORIES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getUserBrands:-', error);
    throw error;
  }
};

export const addPortOfLandingService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.ADD_PORT_OF_LANDING}`, [...data]);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchAllPortoflandingService = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_PORT_OF_LANDING}`);
  } catch (error) {
    console.log('Error: SystemMaster-service: fetchAllPortoflandingService:-', error);
    throw error;
  }
};

export const deletePortOfLandingService = async (deleteId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.DELETE_PORT_OF_LANDING}/${deleteId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllCostingStage = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CS_ITEM}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCostingStageListItem = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CS_ITEM}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteCostingStageListItem = async (data) => {
  try {
    console.log(data, '-----data');
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CS_ITEM}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setCostingStageSeq = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_CS_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductGroups = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET_PRODUCT_GROUP}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addProductGroupData = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.ADD_GROUP_PRODUCT}`, { ...payload });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteProductGroup = async (id, req) => {
  try {
    const queryString = new URLSearchParams(req).toString();
    return await apiClient.delete(`${apiEndpoint}${API.RANGEPLAN_PRODUCT_LIST.GET_PRODUCT_GROUP}/${id}?${queryString}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setGroupSeq = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_PRODUCT_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addDocumentTypeData = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_DOCUMENT_TYPE}`, { ...payload });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchDocumentType = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_DOCUMENT_TYPE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDocumentType = async (data, req) => {
  try {
    const queryString = new URLSearchParams(req).toString();
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.GET_DOCUMENT_TYPE}?${queryString}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setTypeSeq = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_DOCUMENT_TYPE_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductIdentifier = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_IDENTIFIER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addProductIdentifierData = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_IDENTIFIER}`, { ...payload });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteProductIdentifier = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_IDENTIFIER}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductIdentifierChange = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_IDENTIFIER_CHANGE}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const UpdateProductIdentifierType = async (obj) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_IDENTIFIER_CHANGE}`, { ...obj });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setIdentifierSeq = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_IDENTIFIER_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTestTypeMaster = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.TEST_TYPE_MASTER}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setTestTypeSeq = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.TEST_SEQUNCE_MASTER}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllDamAttribute = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_DAM_ATTRIBUTE}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setDamAttrSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_DAM_ATTR_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllSupplierStatus = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.SUPLLIER_STATUS_MASTER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setSupplierStatusSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_SUPPLIER_STATUS_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllBOMComponentTypes = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_BOM_SUB_COMPONENT_MASTER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllBOMTypes:-', error);
    throw error;
  }
};

export const getAutoIdGenerator = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.AUTO_ID_GENERATOR}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveToAutoId = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}/masters${payload?.title}`, {
      ...payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addManualDocumentTypeData = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MANUAL_DOCUMENT_TYPE}`, { ...payload });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchManualDocumentType = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MANUAL_DOCUMENT_TYPE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteManualDocumentType = async (data, req) => {
  try {
    const queryString = new URLSearchParams(req).toString();
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MANUAL_DOCUMENT_TYPE}?${queryString}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveManualTypeSeq = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SAVE_MANUAL_DOCUMENT_TYPE_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setProductIdentifierCounterValueNumber = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_UPDATE_LATEST_COUNTER}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMultiCustomAttribute = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MULTI_CUSTOM_ATTRIBUTE}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getAllBomCustomAttribute = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_BOMATTRIBUTE}`, { params: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveMultiAttribute = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MULTI_CUSTOM_ATTRIBUTE}`, {
      ...payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveBomRespectiveData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_BOMATTRIBUTE}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const deleteMultiCustom = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MULTI_CUSTOM_ATTRIBUTE}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const deleteBomCustomAttributeData = async (data) => {
  console.log('data', data);
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_BOMATTRIBUTE}`, {
      data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInactiveMultiCA = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.ACTIVE_INACTIVE_CUSTOM_ATTRIBUTE}`, data, {
      params: { id: data.customId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveMultiAttributeSeq = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_MULTI_CUSTOM_ATTRIBUTE_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setCustBomAttrSequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_CUST_BOM_SEQUENCE}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const bomActiveInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_BOMATTRIBUTE}`, data, {
      params: { id: data._id },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const AutoToggleButton = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.AUTO_ID_GENERATOR}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const SaveCustomAttributeOptions = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_ATTRIBUTE_VALUE}`, {
      ...payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTypeBasedCatgeory = async (data) => {
  try {
    return await apiClient.post(
      `${apiEndpoint}${API.SYSTEM_MASTER.FETCH_TYPE_BASED_CATEGORY}`,

      { ...data },
    );
  } catch (error) {
    console.log('Error: SystemMaster-service: getTypeBasedCatgeory:-', error);
    throw error;
  }
};
export const saveLengthAccess = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_LENGTH_ACCESS}`, {
      ...payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getLengthAccess = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_LENGTH_ACCESS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getLengthInUseStatus = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_LENGTH_IN_USE_STATUS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setLicensorAccess = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.SET_LICENSOR_ACCESS}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getLicensorAccess = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_LICENSOR_ACCESS}`);
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllLicensor:-', error);
    throw error;
  }
};

export const getAllLicensor = async (data = {}) => {
  try {
    const params = { includeInactive: true, ...data };

    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_LICENSOR}`, {
      params,
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllLicensor:-', error);
    throw error;
  }
};

export const getAllLicense = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_LICENSE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllLicense:-', error);
    throw error;
  }
};

export const getAllLikeness = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_LIKENESS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllLikeness:-', error);
    throw error;
  }
};

export const getPlacementSubBrand = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_PLACEMENT_SUB_BRAND}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllPlacementSubBrand:-', error);
    throw error;
  }
};

export const saveSubBrandAccess = async (payload) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.GET_SUB_BRAND_ACCESS}`, {
      ...payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getSubBrandAccess = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_SUB_BRAND_ACCESS}`);
  } catch (error) {
    console.log('Error: SystemMaster-service: getSubBrandAccess:-', error);
    throw error;
  }
};

export const getMultiSubBrandDetails = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_MULTI_SUB_BRAND}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getMultiSubBrandDetails:-', error);
    throw error;
  }
};

export const getAllIncoterms = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_INCOTERMS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllIncoterms:-', error);
    throw error;
  }
};
export const getAllSubBrand = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_SUB_BRAND}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllSubBrand:-', error);
    throw error;
  }
};

export const saveIncotermsForLicense = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SET_INCOTERMS_FOR_LICENSE}`, {
      ...data,
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllIncoterms:-', error);
    throw error;
  }
};
export const getCustomAttributeDetail = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CUSTOM_ATTRIBUTE_DETAIL}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getCustomAttributeDetail:-', error);
    throw error;
  }
};

export const getPlacementNames = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_PLACEMENT_NAMES}`);
  } catch (error) {
    console.log('Error: SystemMaster-service: getPlacementNames:-', error);
    throw error;
  }
};

export const getCatBasedOnPT = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_CAT_BASED_ON_PT}`);
  } catch (error) {
    console.log('Error: SystemMaster-service: getCatBasedOnPT:-', error);
    throw error;
  }
};

export const getBomCustomAttributes = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_BOM_SOURCE_CUSTOM_ATTRIBUTE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllColourGroups = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_ALL_COLOUR_GROUPS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Composition Process Master Services
export const getAllCompositionProcesses = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.COMPOSITION_PROCESS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllCompositionProcesses:-', error);
    throw error;
  }
};

export const saveCompositionProcessToSystemMaster = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.COMPOSITION_PROCESS}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: saveCompositionProcessToSystemMaster:-', error);
    throw error;
  }
};

export const deleteCompositionProcessFromSystemMasters = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.COMPOSITION_PROCESS}`, {
      data: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: deleteCompositionProcessFromSystemMasters:-', error);
    throw error;
  }
};

export const setCompositionProcessActiveInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.COMPOSITION_PROCESS}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: setCompositionProcessActiveInactive:-', error);
    throw error;
  }
};

// BOM Component Type Master Services
export const getAllBomComponentTypes = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.GET_BOM_COMPONENT_TYPE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllBomComponentTypes:-', error);
    throw error;
  }
};

export const saveBomComponentTypeToSystemMaster = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.GET_BOM_COMPONENT_TYPE}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: saveBomComponentTypeToSystemMaster:-', error);
    throw error;
  }
};

export const deleteBomComponentTypeFromSystemMasters = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.GET_BOM_COMPONENT_TYPE}`, {
      data: { ...data },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: deleteBomComponentTypeFromSystemMasters:-', error);
    throw error;
  }
};

export const setBomComponentTypeActiveInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.GET_BOM_COMPONENT_TYPE}`, data);
  } catch (error) {
    console.log('Error: SystemMaster-service: setBomComponentTypeActiveInactive:-', error);
    throw error;
  }
};

// Product Type Process Master
export const getAllProductTypeProcesses = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_TYPE_PROCESS}`, {
      params: { ...params },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllProductTypeProcesses:-', error);
    throw error;
  }
};

export const saveProductTypeProcessToSystemMaster = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_TYPE_PROCESS}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: saveProductTypeProcessToSystemMaster:-', error);
    throw error;
  }
};

export const deleteProductTypeProcessFromSystemMasters = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_TYPE_PROCESS}`, { data: { ...data } });
  } catch (error) {
    console.log('Error: SystemMaster-service: deleteProductTypeProcessFromSystemMasters:-', error);
    throw error;
  }
};

export const setProductTypeProcessActiveInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.PRODUCT_TYPE_PROCESS}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: setProductTypeProcessActiveInactive:-', error);
    throw error;
  }
};

// Sample Type Group Master
export const getAllSampleTypeGroups = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.SAMPLE_TYPE_GROUP}`, {
      params: { ...params },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllSampleTypeGroups:-', error);
    throw error;
  }
};

export const saveSampleTypeGroupToSystemMaster = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.SAMPLE_TYPE_GROUP}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: saveSampleTypeGroupToSystemMaster:-', error);
    throw error;
  }
};

export const checkSampleTypeInUse = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.CHECK_SAMPLE_TYPE_IN_USE}`, {
      params: { sampleTypeId: params?.sampleTypeId },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: checkSampleTypeInUse:-', error);
    throw error;
  }
};

export const checkAutomationConfigInUse = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.CHECK_AUTOMATION_CONFIG_IN_USE}`, {
      params: {
        sampleTypeGroupId: params?.sampleTypeGroupId,
        fromSampleTypeId: params?.fromSampleTypeId,
        changeToSampleTypeId: params?.changeToSampleTypeId,
      },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: checkAutomationConfigInUse:-', error);
    throw error;
  }
};

export const getSampleTypeGroupInUseAttributeValues = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.SAMPLE_TYPE_GROUP_IN_USE_ATTRIBUTE_VALUES}`, {
      params: { sampleTypeGroupId: params?.sampleTypeGroupId },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getSampleTypeGroupInUseAttributeValues:-', error);
    throw error;
  }
};

export const checkSampleTypeGroupInUse = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.CHECK_SAMPLE_TYPE_GROUP_IN_USE}`, {
      params: { sampleTypeGroupId: params?.sampleTypeGroupId },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: checkSampleTypeGroupInUse:-', error);
    throw error;
  }
};

export const deleteSampleTypeGroupFromSystemMasters = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.SAMPLE_TYPE_GROUP}`, { data: { ...data } });
  } catch (error) {
    console.log('Error: SystemMaster-service: deleteSampleTypeGroupFromSystemMasters:-', error);
    throw error;
  }
};

export const setSampleTypeGroupActiveInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.SAMPLE_TYPE_GROUP}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: setSampleTypeGroupActiveInactive:-', error);
    throw error;
  }
};

export const getSampleTypeGroupsByProduct = async (params) => {
  try {
    return requestWithStatusHandling(apiClient, {
      method: 'get',
      url: `${apiEndpoint}${API.SAMPLES.GET_SAMPLE_TYPE_GROUPS_BY_PRODUCT}`,
      params: { ...params },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getSampleTypeGroupsByProduct:-', error);
    throw error;
  }
};

export const getPartnerOverviewCustomAttributes = async (params) => {
  return apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE}`, { params });
};
/**
 * Additional Variables Master — read the configured additional variables.
 * @param {object} params query parameters forwarded to the endpoint
 * @returns {Promise<object>} the API response body
 */
export const getAllAdditionalVariables = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.ADDITIONAL_VARIABLES}`, {
      params: { ...params },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAllAdditionalVariables:-', error);
    throw error;
  }
};

export const getPartnerOverviewCustomAttributeUsage = async () => {
  return apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_USAGE}`);
};
export const saveAdditionalVariableToSystemMaster = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.ADDITIONAL_VARIABLES}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: saveAdditionalVariableToSystemMaster:-', error);
    throw error;
  }
};

export const savePartnerOverviewCustomAttributes = async (payload) => {
  return apiClient.post(`${apiEndpoint}${API.SYSTEM_MASTER.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE}`, payload);
};

export const deleteAdditionalVariableFromSystemMasters = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.ADDITIONAL_VARIABLES}`, { data: { ...data } });
  } catch (error) {
    console.log('Error: SystemMaster-service: deleteAdditionalVariableFromSystemMasters:-', error);
    throw error;
  }
};

export const updatePartnerOverviewCustomAttribute = async (payload) => {
  return apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE}`, payload);
};

export const setAdditionalVariableActiveInactive = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.ADDITIONAL_VARIABLES}`, { ...data });
  } catch (error) {
    console.log('Error: SystemMaster-service: setAdditionalVariableActiveInactive:-', error);
    throw error;
  }
};

export const setPartnerOverviewCustomAttributeActiveState = async (payload) => {
  return apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_ACTIVE}`, payload);
};
export const getAdditionalVariablesByProduct = async (params) => {
  try {
    return requestWithStatusHandling(apiClient, {
      method: 'get',
      url: `${apiEndpoint}${API.SYSTEM_MASTER.GET_ADDITIONAL_VARIABLES_BY_PRODUCT}`,
      params: { ...params },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAdditionalVariablesByProduct:-', error);
    throw error;
  }
};

export const savePartnerOverviewCustomAttributeSequence = async (payload) => {
  return apiClient.put(`${apiEndpoint}${API.SYSTEM_MASTER.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_SEQUENCE}`, payload);
};

export const deletePartnerOverviewCustomAttribute = async (attributeId) => {
  return apiClient.delete(`${apiEndpoint}${API.SYSTEM_MASTER.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE}`, { params: { attributeId } });
};
export const getAdditionalVariableInUseStatus = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SYSTEM_MASTER.ADDITIONAL_VARIABLES_IN_USE_STATUS}`, {
      params: { additionalVariableId: params?.additionalVariableId },
    });
  } catch (error) {
    console.log('Error: SystemMaster-service: getAdditionalVariableInUseStatus:-', error);
    throw error;
  }
};
